import React, { useMemo, useState, useRef, useLayoutEffect  } from "react";
import styled from "styled-components";
import _ from "lodash";
import "bootstrap/dist/css/bootstrap.css";
import DateTime from "./Components/DateTime.Appointment";
import { useWindowSize } from "../../Utility/hooks";
import { connect } from "react-redux";
import "swiper/swiper.scss";
import "swiper/components/effect-fade";
import 'swiper/components/navigation/navigation.scss';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from 'swiper';
import {chatActions} from '_actions';


const AppointmentWrapper = styled.div`

  background: linear-gradient(180deg, #FDFDFD 0%, #FAFAFA 100%);
  padding: 18px 0;

  @media screen and (min-width: ${(prop) =>
    prop.theme.screenSizes.breakLaptop}) {
      padding: 18px 50px 18px 180px;
     }

  .clicked-slide {
    width: 105px !important;
  }

  .mySwiper {
    .swiper-wrapper {
      display: flex;
      align-items: center;
    }
    .swiper-button-prev, .swiper-button-next {
      width: 32px;
      height: 32px;
      top: 60%;
    }

    .swiper-button-prev:after, .swiper-button-next:after {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 32px;
      height: 32px;
      background: ${(props) => props.theme.themeColors[props.theme.activeTheme].quicklinksBackgroundColorGray};
      color: ${(props) => props.theme.themeColors[props.theme.activeTheme].quicklinkImageText};
      font-size: 14px;
      font-weight: 900;
      border-radius: 50%;
    }

    .swiper-slide {
      width: 88px !important;
      &.time {
        width: 70px !important;
      }
      &.clicked-slide {
        width: 105px !important;
      }
    }

    @media screen and (min-width: ${(prop) =>
      prop.theme.screenSizes.breakLaptop}) {
        
        .swiper-slide {
          width: 125px !important;

          &.time {
            width: 90px !important;
          }
          &.clicked-slide {
            width: 135px !important;
          }
        }
        .swiper-button-prev, .swiper-button-next {
          top: 55%;
        }
        .swiper-button-prev:after, .swiper-button-next:after {
          width: 36px;
          height: 36px;
          top: 55%;
        }
      }
  }
  
`;

const StyledCarouselItem = styled.div`
  padding: 5px 0;
  @media screen and (max-width: ${(props) =>
      props.theme.screenSizes.breakSmall}) {
    flex-wrap: wrap;
  }
`;

const FadeElement = styled.div`
  height: 100%;
  position: absolute;
  width: 90px;
  background-repeat: repeat-x;
  z-index: 10;
  pointer-events:none;
`

const RightFadeElement = styled(FadeElement)`
  left: 0;
  background-image: linear-gradient(
    to right,
    rgba(250, 250, 250, 0.7),
    rgba(250, 250, 250, 0)
  );
`;

const LeftFadeElement = styled(FadeElement)`
  right: 0;
  background-image: linear-gradient(
    to left,
    rgba(255, 255, 255, 0.7),
    rgba(255, 255, 255, 0)
  );
`;

const Sceleton = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  overflow-y: hidden;
  padding: 5px 5px;
  gap: 5px;
  .s-item {
    height: 80px;
    min-width: 70px;
    background: ${(props) => props.theme.themeColors[props.theme.activeTheme].sceletonBackgroundColor};
    border-radius: 12px;
  }

  .s-loader {
    height: 180px;
    top: -35px;
    right: 103%;
    width: 20px;
    background: #FAFAFA;
    width: 20px;
    transform: rotate(45deg);
    position: absolute;
     
    &.animate-loader {
      animation-name: example;
      animation-duration: 1.5s;
      animation-iteration-count: infinite;
      animation-timing-function: linear;

      @keyframes example {
        0% {
          right: 103%;
        }
        100% {
          right: -50px;
        }
    }

   }
  @media screen and (min-width: ${(props) =>
    props.theme.screenSizes.breakLaptop}) {
   .s-item {
     min-width: 90px;
     height: 100px;
   }
}


@media screen and (max-width: ${(props) =>
  props.theme.screenSizes.breakMedium}) {
 .animate-loader  {
   animation-duration: 1s;
 }
`;


const QuickLinkDate = styled.div`
   display: flex;
   justify-content: space-between;
   align-items: center;
   min-width: 115px;
   height: 30px;
   padding: 0px 12px;
   font-size: 13px;
   border-radius: 24px;
   background: ${(props) => props.theme.themeColors[props.theme.activeTheme].main};
   color: white;
   margin-bottom: 10px;
   line-height: 1.3;
   font-family: Plus Jakarta Sans;
   font-weight: 500;
   cursor: pointer;

   img {
    width: 12px;
   }

   &.next {
    margin-left: auto;
   }

   &.previous {
    background: ${(props) => props.theme.themeColors[props.theme.activeTheme].botChatBubbleBackgroundColor};
    color: ${(props) => props.theme.themeColors[props.theme.activeTheme].botChatBubbleTextColor};
   }

   @media screen and (min-width: ${(prop) =>
    prop.theme.screenSizes.breakLaptop}) { 
      height: 40px;
      font-size: 16px;
      min-width: 150px; 
      padding: 0 15px;
    }

    @media screen and (max-width: ${(prop) =>
      prop.theme.screenSizes.breakSmall}) { 
         font-size: 12px;
      }
`
const DateQuickLinksWraper = styled.div`
   display: flex;
   justify-content: space-between;
   padding: 0 18px;
`

const ErrorAppointmentWrapper = styled.div`
height: 100px;
font-size: 20px;
display: flex;
justify-content: center;
align-items: center;
@media screen and (max-width: ${(prop) =>
  prop.theme.screenSizes.breakLaptop}) { 
      font-size: 18px;
  }
@media screen and (max-width: ${(prop) =>
  prop.theme.screenSizes.breakLaptop}) { 
      font-size: 15px;
  }
`

function Appointments({ data, timeIntervals, isLoading, dateQuickLinks, send, hasError, error }) {
  const { width } = useWindowSize();
  const [clickedIndex, setClickedIndex] = useState(999);
  const [sceletonCount, setSceletonCount] = useState(5);
  const swiperRef = useRef(null);

  const itemsApointment = useMemo(() => {
    setSceletonCount(Math.round(width > 1024 ?  swiperRef.current && swiperRef.current.offsetWidth / 90 : width / 80) + 1);
    const fullWidthItems = Math.floor(swiperRef.current && (swiperRef.current.offsetWidth) / 124)
    if(width < 1024) {
      return Math.floor(width / 88)
    }else {
      return fullWidthItems ? fullWidthItems : 10
    }
  }, [width, swiperRef.current])

  const spaceItemsApointment = useMemo(() => {
    if(width < 1024) {
      return  (width - itemsApointment * 86) / itemsApointment
    }else {
      return swiperRef.current && (swiperRef.current.offsetWidth - itemsApointment * 125) / itemsApointment
    }        
  }, [width, swiperRef.current, itemsApointment])

  const spaceItemsTimeApointment = useMemo(() => {
    if(width < 1024) {
      return  (( width - 20)%70) / itemsApointment
    }else {
      return swiperRef.current && (swiperRef.current.offsetWidth - itemsApointment * 90) / itemsApointment
    }        
  }, [width, swiperRef.current, itemsApointment])

  const itemsTimeApointment = useMemo(() => {
    const fullWidthItems = Math.floor(swiperRef.current && (swiperRef.current.offsetWidth) / 90) + 1;
    if(width < 1024) {
      return Math.floor(width / 80)
    }else {
      return fullWidthItems ? fullWidthItems : 10
    }
    
  }, [width, swiperRef.current])

  const items = data.map((el, key) => {
    return (
      <DateTime
        data={el}
        key={`appointments-day-${key}`}
        isHoliday={el.holiday && el.holiday.length > 0}
        onClick={() => setClickedIndex(key)}
        active={clickedIndex === key}
      />
    );
  });

  const intervalItems =
    timeIntervals &&
    timeIntervals.map((el, key) => {
      return (
        <DateTime
          data={el}
          key={`appointments-day=${key}`}
          idHoliday={el.holiday && el.holiday.length > 0}
        ></DateTime>
      );
    });




  const renderDateQuickLInks = dateQuickLinks.map((ql, index) => {
    let positionClass = 'next'
    if((ql.subType.includes('prev'))) {
       positionClass = 'previous'
    }

    if(hasError && index === 1) { 
      positionClass = 'previous'
    }

    let text = ql.text;
    if(!hasError) {
      let qlFirstWordIndex= ql.text.indexOf(" ")
      text = ql.text.slice(0, qlFirstWordIndex === -1 ? dateQuickLinks.lenght: qlFirstWordIndex)
    }

    return <QuickLinkDate className={positionClass} key={ql} onClick={() => send(ql, "text")}>
    {(positionClass === 'previous' || index !== 0) && <img style={{marginRight: '10px'}} src="/images/date-left-arrow.svg" alt="arrow"/>}
    {text} 
    {(positionClass === 'next' && index === 0) && <img style={{marginLeft: '10px'}} src="/images/date-right-arrow.svg" alt="arrow"/>}
     </QuickLinkDate>
  }).reverse();

  const slideOnClick = (swiper, event) => {
    if(event.target.className.includes('next')) {
      swiper.slideNext()
      swiper.slideNext()
      swiper.slideNext()
    }else if(event.target.className.includes('prev'))  {
      swiper.slidePrev()
      swiper.slidePrev()
      swiper.slidePrev()    
    } else if(true) {
      swiper.slideTo(swiper.clickedIndex)
    }
  }

  const removeArrows = (swiper, items, index) => {
    const swiperLength = width >= 1024 ? swiper.slides.length + 3 : swiper.slides.length;

    if(width < 500) return;
    if (swiperLength < items) {
      document.getElementsByClassName('swiper-button-prev')[index].style.display = 'none';
      document.getElementsByClassName('swiper-button-next')[index].style.display = 'none';
    }
    else if (swiper.activeIndex === 0) {
      document.getElementsByClassName('swiper-button-prev')[index].style.display = 'none';
      document.getElementsByClassName('swiper-button-next')[index].style.display = 'block';
    }
    else if ((swiper.activeIndex !== 0) && (swiper.activeIndex <= (swiperLength - items))) {
      document.getElementsByClassName('swiper-button-prev')[index].style.display = 'block';
      document.getElementsByClassName('swiper-button-next')[index].style.display = 'block';
    }
    else if (swiper.activeIndex > swiperLength - items) {
      document.getElementsByClassName('swiper-button-prev')[index].style.display = 'block';
      document.getElementsByClassName('swiper-button-next')[index].style.display = 'none';
    }
  }

 
  return (
    <AppointmentWrapper style={{pointerEvents: `${isLoading ? "none" : 'auto'}`}} >
      { hasError && <ErrorAppointmentWrapper>{error}</ErrorAppointmentWrapper>}
      <DateQuickLinksWraper>
      {renderDateQuickLInks}
      </DateQuickLinksWraper>
   
      <RightFadeElement></RightFadeElement>
      <LeftFadeElement></LeftFadeElement>
     { !hasError && <Swiper
        ref={swiperRef}
        modules={[ Navigation]}
        slidesPerView={itemsApointment}
        spaceBetween={spaceItemsApointment}
        centeredSlides={width < 500}
        slidesOffsetBefore={width >= 500 ? 60 : 0}
        slidesOffsetAfter={width}
        className="mySwiper"
        navigation={width >= 500}
        allowTouchMove={width < 500}
        onClick={slideOnClick}
        onSlideChange={(swiper) => removeArrows(swiper, itemsApointment, 0)}
        onBeforeSlideChangeStart={(swiper) => removeArrows(swiper, itemsApointment, 0)}
      >
        {
          items.map((el, index) => {
            return (
              <SwiperSlide
                className={index === clickedIndex && "clicked-slide"}
                key={"carousel-datetime-" + index} 
              >
                    <StyledCarouselItem
                      key={index}
                      onClick={() => setClickedIndex(index)}
                      className="StyledCarouselItem"
                    >
                      {el}
                    </StyledCarouselItem>
              </SwiperSlide>
            );
          })
        }
      </Swiper>}

      {isLoading && (
        <Sceleton>
          <div className="s-loader animate-loader"></div>
         {Array(sceletonCount).fill(<div className="s-item"></div>)}
        </Sceleton>
      )}

      {timeIntervals && !isLoading && !hasError && (
        <Swiper
        modules={[ Navigation]}
          slidesPerView={itemsTimeApointment}
          spaceBetween={10}
          navigation={width >= 500}
          centeredSlides={width < 500}
          className="mySwiper"
          slidesOffsetBefore={width >= 500 ? 60 : 0}
          slidesOffsetAfter={width + 500}
          speed={600}
          allowTouchMove={width < 500}
          onClick={slideOnClick}
          onSlideChange={(swiper) => removeArrows(swiper, itemsTimeApointment, 1)}
          onBeforeSlideChangeStart={(swiper) => removeArrows(swiper, itemsTimeApointment, 1)}
        >
          {
            intervalItems.map((el, index) => {
              return (
                <SwiperSlide key={"carousel-time-" + index} className="time">
                  <StyledCarouselItem className="StyledCarouselItem date">
                    {el}
                  </StyledCarouselItem>
                </SwiperSlide>
              );
            })
          }
        </Swiper>
      )}
    </AppointmentWrapper>
  );
}

const mapStateToProps = (state) => {
  return ({
  timeIntervals: state.date.timeIntervals,
  isLoading: state.date.isLoading,
  dateQuickLinks: state.date.dateQuickLinks,
  hasError: state.date.hasError,
  error: state.date.error,
})};

const actions = {
  send: chatActions.send,
}

export default connect(mapStateToProps, actions)(Appointments);
